import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

const {
  grid: { resolution, spacing },
  primaryColours,
  borderRadius,
} = theme

export const ExplainerSectionStyles = styled.div`
  flex: 1;
  gap: ${spacing.s}px;
  border-radius: ${borderRadius.double};
  background-color: white;
  .section {
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: ${spacing.xs}px;

    .title {
      margin: 0 30px;
    }

    .text {
      margin-top: ${spacing.s}px;
      color: ${primaryColours.aubergine.main};
    }

    .content {
      padding: ${spacing.s}px ${spacing.xs}px ${spacing.xs}px;
    }
  }

  .image {
    width: 100%;
    height: auto;
  }

  @media (min-width: ${resolution.tablet.width}px) {
    .image {
      height: 96px;
      object-fit: cover;
    }
  }

  @media (min-width: ${resolution.desktop.width}px) {
    flex-direction: row;

    .section {
      .title {
        margin: 0 36px;
      }
    }
  }
`
